import { http } from "./http";
import type { FollowState } from "../data/types";

/**
 * Vänbjudan.
 *
 * Förhandsvisningen är den enda endpointen i klienten som anropas utloggad
 * med ett hemligt värde i URL:en, och den svarar därför med ett namn och
 * ingenting mer. Allt annat kräver inloggning, och backend är den som
 * avgör — klientens kontroller nedan finns för att slippa onödiga anrop,
 * inte för att skydda något.
 */

export type InviteConnection = "none" | "pending" | "connected" | "self";

export type FriendInvite = {
  token: string;
  /** Absolut URL, byggd av backend ur APP_PUBLIC_URL. Det är den vi delar. */
  url: string;
  expiresAt: string;
  createdAt: string;
  openedAt: string | null;
  convertedAt: string | null;
};

export type FriendInvitePreview = {
  invite: { token: string; expiresAt: string };
  from: {
    /** Saknas när mottagaren är utloggad — då är namnet allt vi skickar. */
    id?: string;
    displayName: string;
    avatarUrl: string | null;
  };
  viewer: {
    authenticated: boolean;
    isSelf: boolean;
    followState: FollowState;
    followsYou: boolean;
    connection: InviteConnection;
  };
};

export type AcceptResult = {
  status: "requested" | "already_connected";
  followState: FollowState;
  followsYou: boolean;
  connection: InviteConnection;
};

/** Hämtar min aktiva länk, eller skapar en. Samma länk vid upprepade anrop. */
export function createFriendInvite() {
  return http.post<{ invite: FriendInvite }>("/friend-invites");
}

/** Gör den delade länken obrukbar. Nästa createFriendInvite ger en ny. */
export function revokeFriendInvite() {
  return http.delete<{ ok: boolean; revoked: number }>("/friend-invites");
}

export function fetchFriendInvite(token: string) {
  return http.get<FriendInvitePreview>(
    `/friend-invites/${encodeURIComponent(token)}`
  );
}

export function acceptFriendInvite(token: string) {
  return http.post<AcceptResult>(
    `/friend-invites/${encodeURIComponent(token)}/accept`
  );
}
